'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = classnames;
function classnames() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return names.filter(Boolean).join(' ');
}